export class CommentsModel {
    numberOfCommentsWithReplies: number;
    pageData: [];
    pageIndex: number = 0;
    pageSize: number = 5;
    totalCount: number;
}
